import React from "react";
import RecapItemRow from "../molecules/RecapItemRow";
import BureauCard from "../atoms/BureauCard";
import { INK, INK_3, LINE } from "../bureauTokens";

function RecapItemRowSkeleton() {
  return (
    <div style={{ borderRadius: 9, padding: "7px 9px" }} className="space-y-1.5">
      <div className="h-2.5 w-24 rounded animate-pulse" style={{ background: LINE }} />
      <div className="h-2.5 w-32 rounded animate-pulse" style={{ background: LINE }} />
    </div>
  );
}

function RecapCard({ title, items, onOpenItem, loading }) {
  return (
    <BureauCard>
      <div className="text-[11px] font-semibold mb-2" style={{ color: INK }}>
        {title}
      </div>
      <div className="space-y-1">
        {loading ? (
          Array.from({ length: 3 }).map((_, i) => <RecapItemRowSkeleton key={i} />)
        ) : (
          <>
            {items.map((item) => (
              <RecapItemRow
                key={item.id}
                client={item.client}
                sub={item.sub}
                right={item.right}
                tone={item.tone}
                onClick={() => onOpenItem(item)}
              />
            ))}
            {items.length === 0 && (
              <div className="py-6 text-center text-xs" style={{ color: INK_3 }}>
                Rien à afficher
              </div>
            )}
          </>
        )}
      </div>
    </BureauCard>
  );
}

export default RecapCard;
